import React from "react";
import { createRoot } from "react-dom/client";
import { App } from "./components/App/App";
import { setupViewHeight } from "./setup/setupVh";

window.invalidTokenEvent = new Event("invalidToken");

const container = document.getElementById("root");
const root = createRoot(container as HTMLElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

setupViewHeight();
